import component from './HotelSearchResultsCaption';

export default component;
